/**
 * The Blacklist tab mixes two kinds of row: contacts (identified by their prospect id) and blacklist
 * entries that no contact matches yet (identified by their entry id). Both travel in the same `ids`
 * payload, so entry rows are encoded as the negative of their entry id — mirrors
 * `apps/api/src/contact/blacklist/contact-blacklist-row-id.helper.ts`.
 */

/** True when the row addresses a blacklist entry rather than a contact. */
export function isBlacklistEntryRowId(rowId: number): boolean {
	return rowId < 0;
}

/** True when the row has no contact record behind it (no lead panel, nothing to snooze). */
export function hasContactRecord(row: { id: number }): boolean {
	return !isBlacklistEntryRowId(row.id);
}
